import { useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';

import { TopBar } from '@app/shared/ui/organisms/Admin/Common';
import {
  UserInfoSection,
  // SettlementsSection,
  // StonesSection,
} from '@app/shared/ui/organisms/Admin/UserDetails';
import { NotFound } from '@app/shared/ui/molecules/Common';
import { useFindUserQuery } from '@app/store/slices/admin/adminApi';
import { Page } from '@app/routes';
import { FindUserBy } from '@app/shared/types/admin/common';
import { LoadingSpinner } from '@app/shared/ui/atoms/Common';

export default function AdminUserDetailsPage() {
  const { id } = useParams();

  const { data: user, isLoading: isUserLoading } = useFindUserQuery(
    id ? { value: id, searchType: FindUserBy.USER_ID } : skipToken
  );

  if (isUserLoading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <NotFound withLightBlueBg />;
  }

  const profile = user.profile;
  const finance = user.finance;
  const curator = user.curator;

  // TODO: uncomment settlements and stones sections once we have data
  return (
    <div>
      <TopBar
        url={`${Page.ADMIN_BALANCE}?findUserBy=${FindUserBy.USER_ID}&findUserValue=${String(user.id)}`}
        translationKey="admin_user_details.update_balance"
      />

      <UserInfoSection
        user={{
          id: user.id,
          fullName: profile?.fullName,
          telegramUsername: user.telegramUsername,
          telegramId: user.telegramId,
          avatar: profile?.avatar,
          // gender: mockUserDetails.profile.gender,
          gender: 'f',
          cookieBalance: finance?.cookieBalance,
          tonBalance: finance?.tonBalance,
          tonFrozenBalance: finance?.tonFrozenBalance,
        }}
        curator={{
          id: curator?.id,
          fullName: curator?.profile?.fullName,
          telegramUsername: curator?.telegramUsername,
          telegramId: curator?.telegramId,
        }}
      />

      {/*<SettlementsSection settlements={mockUserDetails.settlements} />*/}

      {/*<StonesSection stones={mockUserDetails.stones} />*/}
    </div>
  );
}
